import { all } from 'redux-saga/effects';

import projectIdentificationSaga from './project-identification-saga';

export default function* rootSaga() {
  yield all([projectIdentificationSaga()]);
}
